
import { ReservationItemModule } from '@/store/modules/reservationItem';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'AncillaryFaciliry',
  components: {
  },
})
export default class extends Vue {
  get formData() {
    return ReservationItemModule.form;
  }

  get additionalGroups() {
    return ReservationItemModule.form.additionalGroups;
  }

  private unitList = [
    {
      uid: '84654',
      value: '',
      label: '없음',
    },
    {
      uid: '123494',
      value: 'minute',
      label: '분',
    },
    {
      uid: '894321',
      value: 'time',
      label: '시간',
    },
    {
      uid: '84321',
      value: 'day',
      label: '일',
    },
    {
      uid: '654984',
      value: 'number',
      label: '회',
    },
  ];

  private handleDeleteGroup(group: any, index: number) {
    this.$confirm(`정말 그룹(${group.name})을(를) 삭제하시겠습니까?`, '부속시설 그룹 삭제', {
      confirmButtonText: '삭제',
      cancelButtonText: '취소',
      type: 'error',
    }).then(() => {
      this.additionalGroups.splice(index, 1);
    });
  }

  private handleAddGroup() {
    const defaultAdditionalGroup: any = {
      name: '',
      multipleStatus: false,
      items: [
        {
          name: '',
          amount: 0,
          unit: '',
          price: 0,
        },
      ],
    };
    this.additionalGroups.push(defaultAdditionalGroup);
  }

  private handleDeleteItem(group: any, index: number) {
    if (group.items.length === 1) {
      this.$message({
        duration: 2000,
        type: 'warning',
        message: '그룹 아래 부속시설은 하나 이상이어야 합니다.',
      });
    } else {
      group.items.splice(index, 1);
    }
  }

  private handleAddItem(group: any, index: number) {
    const defaultAdditionalItem: any = {
      name: '',
      amount: 0,
      unit: '',
      price: 0,
    };
    group.items.splice(index + 1, 0, defaultAdditionalItem);
  }
}
